import {
  ScmAuth,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  scmAuthApiRef,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  identityApiRef,
  storageApiRef,
} from '@backstage/core-plugin-api';
import { visitsApiRef, VisitsStorageApi } from '@backstage/plugin-home';
import { BackstageInsights } from '@spotify/backstage-plugin-analytics-module-insights';
import {
  githubPullRequestsApiRef,
  GithubPullRequestsClient,
} from '@roadiehq/backstage-plugin-github-pull-requests';
import { AccTechRadarApi } from '@internal/backstage-plugin-acc-techradar';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),

  createApiFactory({
    api: githubPullRequestsApiRef,
    deps: { configApi: configApiRef, scmAuthApi: scmAuthApiRef },
    factory: ({ configApi, scmAuthApi }) =>
      new GithubPullRequestsClient({ configApi, scmAuthApi }),
  }),

  // Implementation that relies on a provided storageApi
  createApiFactory({
    api: visitsApiRef,
    deps: {
      storageApi: storageApiRef,
      identityApi: identityApiRef,
    },
    factory: ({ storageApi, identityApi }) =>
      VisitsStorageApi.create({ storageApi, identityApi }),
  }),
  ScmAuth.createDefaultApiFactory(),
  AccTechRadarApi.createDefaultApiFactory(),
  BackstageInsights.createDefaultApiFactory(),
];
